<template>
	<section v-if="show">
		<slot name="header"></slot>
		<section class="permits">
			<permits-item-notification />
			<permits-item-location />
			<permits-item-install />
		</section>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import PermitsItemInstall from '@/modules/permits/PermitsItemInstall'
import PermitsItemNotification from '@/modules/permits/PermitsItemNotification'
import PermitsItemLocation from '@/modules/permits/PermitsItemLocation'
export default {
	name: 'permits',
	components: {
		PermitsItemInstall,
		PermitsItemNotification,
		PermitsItemLocation
	},
	computed: {
		show() {
			return !this.location.granted || !this.notifications.granted || !this.install.granted
		},
		...mapGetters({
			location: 'GET_LOCATIONS',
			notifications: 'GET_NOTIFICATIONS',
			install: 'GET_INSTALL'
		})
	}
}
</script>

<style scoped>
.permits {
	padding: 10px 0;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	grid-column-gap: 15px;
	grid-row-gap: 15px;
}
</style>



// WEBPACK FOOTER //
// src/modules/permits/Permits.vue